// Port of api/fuel/app/classes/insights/collection/rarity.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'rarity',
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        var rarityType = (filter.rarity !== undefined) ? filter.rarity : 'most'

        var raw = Util.queryFast('\
            SELECT \
                g.game_id AS g, \
                g.game_own AS c \
            FROM \
                collection c \
                JOIN \
                game g \
                ON \
                c.game_id = g.game_id \
            WHERE \
                c.user_id IN (' + Util.in(userIndex) + ') \
                AND \
                c.collection_own = 1 \
                AND \
                c.collection_expansion = 0 \
                AND \
                g.game_own > 0 \
            GROUP BY \
                g.game_id \
            ORDER BY \
                g.game_own ' + ((rarityType === 'most') ? 'ASC' : 'DESC') + ', \
                g.game_sortname ASC \
            ' + (detail ? 'LIMIT 0, 100' : 'LIMIT 0, 5') + ' \
        ')

        var rarity = []

        for (var i = 0; i < raw.length; i++) {
            this._references.games.push(raw[i].g)

            rarity.push({
                id: parseInt(raw[i].g, 10),
                count: parseInt(raw[i].c, 10)
            })
        }

        return {
            rarity: rarity
        }

    }
})
